import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiGet, apiPost, apiPatch } from './api';
import { IAnnouncement, IAnnouncementCreateDto } from '../types/announcements.types';

const { REACT_APP_ORGANIZATION } = process.env;

export const getActiveAnnouncements = async (): Promise<IAnnouncement[]> => {
  return apiGet<AxiosRequestConfig, IAnnouncement[]>(`${REACT_APP_ORGANIZATION}/announcement`)
    .then(response => Promise.resolve(response || []))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const createOrUpdateAnnouncement = async (data: IAnnouncementCreateDto): Promise<IAnnouncement> => {
  return apiPost<AxiosRequestConfig, IAnnouncementCreateDto, AxiosResponse<IAnnouncement>>(
    `${REACT_APP_ORGANIZATION}/announcement`,
    data
  )
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const deactivateAnnouncement = async (): Promise<IAnnouncement> => {
  return apiPatch<AxiosRequestConfig, void, IAnnouncement>(`${REACT_APP_ORGANIZATION}/announcement/deactivate`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
